var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isDestroyed
        ? _c("right-popup", {
            attrs: {
              show: _vm.isShow,
              "border-left": false,
              "border-top": true,
              width: 300,
              "exclude-header": true,
              "exclude-footer": true,
              "custom-styles": { zIndex: 9 },
              "portal-name": "portal-columns-sidebar",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "transition",
                        { attrs: { name: "slide-right-left", mode: "out-in" } },
                        [
                          _c(_vm.viewConfig.view, {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.onClickOutside,
                                expression: "onClickOutside",
                              },
                            ],
                            key: _vm.viewConfig.view,
                            tag: "component",
                            attrs: { "view-config": _vm.viewConfig },
                            on: {
                              onClose: _vm.closeClick,
                              backClick: _vm.backClick,
                              onCreateNewColumnClick:
                                _vm.onCreateNewColumnClick,
                              onUseExistedColumnClick:
                                _vm.onUseExistedColumnClick,
                              openEditBar: _vm.openEditBar,
                              onDeleteClick: _vm.onDeleteClick,
                              changeView: _vm.changeView,
                              helpIconClick: _vm.showHelpPopup,
                              changeCheckbox: _vm.changeCheckbox,
                              updateConfig: _vm.updateConfig,
                              saveNewColumn: _vm.saveNewColumn,
                              onReuseExistingColumn: _vm.onReuseExistingColumn,
                              redirectToSettings: _vm.redirectToSettings,
                              changeCheckboxOption: _vm.changeCheckboxOption,
                              setUserChangesFlag:
                                _vm.disableGanttAndViewsByUserChanges,
                              showChangesConfirmation:
                                _vm.showChangesConfirmation,
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3525521132
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("core-confirm-popup", {
        attrs: {
          show: _vm.isShowRemoveConfirmation,
          "popup-width": "440",
          "button-width": "130px",
          "close-icon": "",
          title: _vm.locales("columns_bar_remove_confirm_title"),
          text: _vm.locales("columns_bar_remove_confirm_text"),
          "cancel-button": {
            title: _vm.locales("common_cancel"),
            type: "secondary",
          },
          "ok-button": {
            title: _vm.locales("common_remove"),
            type: "destructive",
          },
        },
        on: {
          onClickCancel: _vm.cancelDeletion,
          onClickOk: _vm.deleteFromPopup,
        },
      }),
      _vm._v(" "),
      _c("core-confirm-popup", {
        attrs: {
          show: _vm.isShowChangesConfirmation,
          "popup-width": "440",
          "button-width": "130px",
          "close-icon": "",
          title: _vm.locales("columns_bar_changes_confirm_title"),
          text: _vm.locales("custom_column_changes_confirm_message"),
          "cancel-button": {
            title: _vm.locales("common_cancel"),
            type: "secondary",
          },
          "ok-button": { title: _vm.locales("common_ok"), type: "primary" },
        },
        on: {
          onClickCancel: _vm.cancelUserChanges,
          onClickOk: _vm.saveUserChanges,
        },
      }),
      _vm._v(" "),
      _c("core-confirm-popup", {
        attrs: {
          show: _vm.isShowUnsavedConfirmation,
          "popup-width": "440",
          "button-width": "130px",
          "close-icon": "",
          title: _vm.locales("columns_bar_unsaved_changes_confirm_title"),
          text: _vm.locales("columns_bar_unsaved_changes_confirm_message"),
          "cancel-button": {
            title: _vm.locales("common_cancel"),
            type: "secondary",
          },
          "ok-button": {
            title: _vm.locales("common_confirm"),
            type: "primary",
          },
        },
        on: { onClickCancel: _vm.cancelAction, onClickOk: _vm.confirmAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }